<template>
  <div class="gc-login-wrap">
    <div class="logo-corner">
      <img class="brand-logo" src="~@/assets/logo.png" alt="PSAC 感知技能鉴定中心">
    </div>
    <div class="hero-wrap">
      <h1 class="brand-title">全效智能体</h1>
      <div class="brand-slogan">AI 驱动绩效 · 效率倍增</div>
      <div class="brand-subtitle">感知技能鉴定中心 · PERCEPTION SKILLS ASSESSMENT CENTER</div>
    </div>
    <div class="login-wrap">
      <div class="input-wrap">
        <i class="i1"></i>
        <input type="text" v-model="username" class="input" placeholder="请输入手机号">
      </div>
      <div class="input-wrap">
        <i class="i2"></i>
        <input v-if="toggleEye" type="text" v-model="password" class="input" placeholder="请输入密码">
        <input v-else type="password" v-model="password" class="input" placeholder="请输入密码">
        <i class="eye" :class="{'open':toggleEye}" @click="toggleEye = !toggleEye"></i>
      </div>
      <div class="submit-btn" @click="onLogin">登 录</div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      username: '',
      password: '',
      toggleEye: false
    }
  },
  mounted() {
    if (localStorage.getItem('UserSysno')) {
      this.$router.replace('/')
    }
  },
  methods: {
    onLogin() {
      if (!this.username) {
        this.$toast('请输入手机号')
        return
      }
      if (!this.password) {
        this.$toast('请输入密码')
        return
      }
      if (!this.username.match(/^1[3456789]\d{9}$/)) {
        this.$toast('请输入正确的手机号')
        return
      }
      let data = {
        UserName: this.username,
        PassWord: this.password
      }
      this.$baseajax.normalJsonp(this.$base.baseapi + '/WebUserLogin', data, res => {
        console.log(res);
        res = res.WebUserLoginResult;
        if (res.ResponseCode == 1) {
          //所属公司
          localStorage.setItem('UserComSysno', res.UserComSysno)
          //用户编号
          localStorage.setItem('UserSysno', res.userSysno)
          //用户编号
          localStorage.setItem('CrmUserId', res.CrmUserId)
          //部门编号
          localStorage.setItem('GovDepSysno', res.GovDepSysno)
          localStorage.setItem('IsSatis', res.IsSatisfactionTeam || 0)
          //是否为部门负责人
          if (res.userSysno == "US2018040813033200040") {
            localStorage.setItem('ReponseLog', 0)
          } else {
            localStorage.setItem('ReponseLog', res.ReponseLog)
          }
          //是否拥有审核工具权限
          localStorage.setItem('isaudit', res.isaudit)
          localStorage.setItem('isfirst', res.isfirst)
          if (res.userSysno == "US2018040813033200040") {
            localStorage.setItem('isBoss', 1)
            localStorage.setItem('CoreIsBoss', 'true')
          } else {
            localStorage.removeItem('isBoss')
            localStorage.removeItem('CoreIsBoss')
          }
          window.dispatchEvent(new CustomEvent('identity-updated'))

          if (res.isfirst == 1) {
            this.$router.push({
              name: 'Password'
            })
          } else {
            // 若运行在健康小屋小程序的 web-view 内，把登录态回传给小程序，由小程序打开效率页
            if (window.__wxjs_environment === 'miniprogram' || (typeof wx !== 'undefined' && wx.miniProgram)) {
              try {
                const fields = {
                  UserComSysno: res.UserComSysno,
                  UserSysno: res.userSysno,
                  CrmUserId: res.CrmUserId,
                  GovDepSysno: res.GovDepSysno,
                  IsSatis: res.IsSatisfactionTeam || 0,
                  ReponseLog: res.userSysno === 'US2018040813033200040' ? 0 : res.ReponseLog,
                  isaudit: res.isaudit,
                  isfirst: res.isfirst,
                  isBoss: res.userSysno === 'US2018040813033200040' ? 1 : 0
                }
                const data = Object.keys(fields)
                  .map(k => `${encodeURIComponent(k)}=${encodeURIComponent(fields[k] == null ? '' : fields[k])}`)
                  .join('&')
                wx.miniProgram.postMessage({data: {type: 'okrLogin', data}})
              } catch (e) {
                console.error('postMessage to miniprogram failed', e)
              }
            }
            this.$router.replace('/')
          }
        } else {
          this.$toast(res.ResponseMessage)
        }
      }, err => {
      })
    }
  },
}
</script>

<style lang="less" scoped>
@brand-red: #D32F2F;
@brand-black: #1A1A1A;
@brand-bg: #F8F9FA;

.gc-login-wrap {
  min-height: 100vh;
  background: linear-gradient(180deg, #FFFFFF 0%, #F8F9FA 40%, #ECEFF1 100%);
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;

  .logo-corner {
    position: absolute;
    top: 0.4rem;
    right: 0.4rem;
    z-index: 2;

    .brand-logo {
      width: 1.4rem;
      height: auto;
      object-fit: contain;
      display: block;
      mix-blend-mode: multiply;
    }
  }

  .hero-wrap {
    padding-top: 2.2rem;
    text-align: center;
    width: 8.5rem;

    .brand-title {
      font-size: 1.1rem;
      font-weight: 900;
      letter-spacing: 0.1rem;
      line-height: 1.2;
      background: linear-gradient(135deg, #D32F2F 0%, #B71C1C 50%, #1A1A1A 100%);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      filter: drop-shadow(0 0.04rem 0.16rem rgba(211, 47, 47, 0.35));
      display: inline-block;
    }

    .brand-slogan {
      margin-top: 0.28rem;
      font-size: 0.32rem;
      font-weight: 700;
      color: @brand-red;
      letter-spacing: 0.08rem;
    }

    .brand-subtitle {
      margin-top: 0.2rem;
      font-size: 0.22rem;
      color: #666666;
      line-height: 1.4;
      padding: 0 0.4rem;
    }
  }

  .login-wrap {
    margin: 0.8rem auto 0;
    width: 8.12rem;
    padding: 0.8rem 0.7rem 1rem;
    background-color: #ffffff;
    box-shadow: 0rem 0.08rem 0.6rem 0rem rgba(26, 26, 26, 0.10);
    border-radius: 0.32rem;
    border-top: 0.08rem solid @brand-red;

    .input-wrap {
      margin-top: .7rem;
      border-bottom: 1px solid #E0E0E0;
      position: relative;
      line-height: 1;
      transition: border-color 0.2s;

      &:focus-within {
        border-bottom-color: @brand-red;
      }

      &:first-child {
        margin-top: 0;
      }

      .input {
        width: 100%;
        padding: .2rem 0.88rem;
        font-size: 0.37rem;
        color: @brand-black;
        background: transparent;

        &::placeholder {
          color: #999999;
        }
      }

      i {
        display: block;
        position: absolute;
        left: 0;
        top: 50%;
        width: 0.4rem;
        height: 0.4rem;
        margin-top: -0.2rem;
        background-repeat: no-repeat;
        background-size: contain;

        &.i1 {
          background-image: url('~@/assets/login1.png');
        }

        &.i2 {
          background-image: url('~@/assets/login2.png');
        }

        &.eye {
          position: absolute;
          right: 0;
          left: auto;
          top: 50%;
          margin-top: -0.16rem;
          background-image: url('~@/assets/eye.png');

          &.open {
            background-image: url('~@/assets/eye2.png');
          }
        }
      }
    }

    .submit-btn {
      margin-top: 1.2rem;
      width: 100%;
      height: 1.2rem;
      line-height: 1.2rem;
      background: linear-gradient(135deg, @brand-red 0%, #B71C1C 100%);
      box-shadow: 0rem 0.08rem 0.24rem 0rem rgba(211, 47, 47, 0.35);
      border-radius: 0.6rem;
      font-size: 0.48rem;
      font-weight: 600;
      color: #ffffff;
      text-align: center;
      letter-spacing: 0.08rem;

      &:active {
        opacity: 0.92;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Login.vue